module.exports = __webpack_public_path__ + "static/media/DSC_0222.ae7bed74.jpg";